import { baseApi } from "common/redux/core/api.base";
import { KnowledgeAgentService } from "../../services/knowledge-agent.service";
import {
  DocumentApiResponse,
  ReferenceStandardApiItem,
  SpecAuditSessionResponse
} from "../../models/knowledge-agent.model";

const knowledgeAgentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getKnowledgeAgentDocuments: build.query<DocumentApiResponse, void>({
      queryFn: () => {
        return KnowledgeAgentService.getAdminDocuments();
      },
      providesTags: ["KNOWLEDGE_AGENT"]
    }),
    getReferenceStandards: build.query<ReferenceStandardApiItem[], void>({
      queryFn: () => {
        return KnowledgeAgentService.getAllReferenceStandards();
      },
      providesTags: ["KNOWLEDGE_AGENT"]
    }),
    getSpecAuditSession: build.query<SpecAuditSessionResponse, string>({
      queryFn: (sessionId: string) => {
        return KnowledgeAgentService.getSpecAuditSession(sessionId);
      }
    }),
    getAllSpecAuditSessions: build.query<SpecAuditSessionResponse[], void>({
      queryFn: () => {
        return KnowledgeAgentService.getAllSpecAuditSessions();
      },
      providesTags: ["KNOWLEDGE_AGENT"]
    })
  })
});

export const {
  useGetKnowledgeAgentDocumentsQuery,
  useGetReferenceStandardsQuery,
  useGetSpecAuditSessionQuery,
  useGetAllSpecAuditSessionsQuery
} = knowledgeAgentApi;
